import React from "react"
import { ChildrenNode, Matcher, MatchResponse, Node } from "interweave"
import i18n from "@/lib/i18n/i18n"

export interface GoogleMapsMatcherProps {
  href: string
}

/**
 * Custom Interweave matcher for Google Maps URLs
 * Replaces Google Maps URLs with a standardized "📍 Open in Google Maps" text
 */
export class GoogleMapsMatcher extends Matcher<GoogleMapsMatcherProps> {
  /**
   * Match Google Maps URLs that start with https://www.google.com/maps/
   */
  match(string: string): MatchResponse<{ href: string }> | null {
    // Regex pattern to match Google Maps URLs
    const googleMapsPattern = /https:\/\/www\.google\.com\/maps\/[^\s<>"]+/i

    const result = string.match(googleMapsPattern)

    if (!result) {
      return null
    }

    return {
      index: result.index!,
      length: result[0].length,
      match: result[0],
      href: result[0],
      valid: true,
    }
  }

  /**
   * Replace the matched URL with a custom anchor element
   */
  replaceWith(children: ChildrenNode, props: GoogleMapsMatcherProps): Node {
    return (
      <a
        href={props.href}
        target="_blank"
        rel="noopener noreferrer"
        className="inline-flex items-center gap-1 text-blue-600 hover:text-blue-800 hover:no-underline"
      >
        📍 {i18n.t("maps.routeLinks.openInGoogleMaps")}
      </a>
    )
  }

  /**
   * Return the HTML tag name for this matcher
   */
  asTag(): string {
    return "a"
  }
}
